import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { addressColumns, randomData } from './data/datable.data';
import { AddSiteComponent } from './components/add-site/add-site.component';
import { SiteAdresseDetailComponent } from './components/site-adresse-detail/site-adresse-detail.component';
import { MatDialog } from '@angular/material/dialog';
import { AdresseDto, Establishment } from '../../../../../models/Establishment';
import { AddressService } from '../../../../../services/address.service';
import { AuthService } from '../../../../../services/auth.service';
import { EstablishmentService } from '../../../../../services/establishment.service';
import { FormBuilder } from '@angular/forms';
import { Subject, debounceTime } from 'rxjs';
import { MatPaginator } from '@angular/material/paginator';
import { DataTableComponent } from '../../../../../shared/data-table/data-table.component';

@Component({
  selector: 'app-sites-adresses',
  templateUrl: './sites-adresses.component.html',
  styleUrl: './sites-adresses.component.scss',
})
export class SitesAdressesComponent implements OnInit {
  @ViewChild(DataTableComponent) childComponent: DataTableComponent;
  @Input() establishment: Establishment;
  addressList: AdresseDto[] = [];
  loading = false;
  totalItems = 0;
  pageSize = 0;
  pageIndex = 0;
  offset = 0;
  limit = 10;
  form = this.fb.group({
    etablissementId: this.auth.id,
    keyword: [''],
    offset: this.offset,
    limit: this.limit,
  });

  protected readonly addressColumns = addressColumns;
  constructor(
    private dialog: MatDialog,
    private addressService: AddressService,
    private establishmentService: EstablishmentService,
    private fb: FormBuilder,
    private auth: AuthService
  ) {
    // Define a function to generate a random element
    function getRandomElement<T>(array: T[]): T {
      return array[Math.floor(Math.random() * array.length)];
    }
  }

  openAddSiteDialog() {
    const dialog = this.dialog.open(AddSiteComponent, {
      width: '700px',
      autoFocus: false,
      data: {
        isModify: false,
      },
    });
    dialog.afterClosed().subscribe((value) => {
      if (value) {
        // this.establishmentService.getEstablishmentById(this.auth.id).subscribe({
        //   next: (res) => {
        //     if (res) {
        this.getAddresses();
      }
      // },
      // });
      // }
    });
  }

  handleRowClick = (row: any) => {
    this.dialog.open(SiteAdresseDetailComponent, {
      width: '666px',
      height: '100vh',
      position: { right: '0' },
      backdropClass: 'bg-transparent',
      data: row,
      // animation: { to: "left" }
    });
  };

  ngOnInit(): void {
    // this.getAddresses()
    // this.addressList = this.auth.establishment?.adresses!
    this.totalItems = this.addressList.length;
    // this.getAddresses();
    this.form
      .get('keyword')
      ?.valueChanges.pipe(debounceTime(700))
      .subscribe((value) => {
        this.form.get('offset')?.patchValue(this.offset);
        this.form.get('limit')?.patchValue(this.limit);
        this.pageIndex = 0;

        this.pagination({
          pageIndex: 0,
        });
        // this.firstPage();
        this.childComponent.returnToFirstPage();
      });

    this.addressService.getRefreshData().subscribe({
      next: () => {
        this.getAddresses();
      },
    });
  }

  getAddresses() {
    this.loading = true;
    this.addressService.getAddressesFilter(this.form.value, "/v2").subscribe({
      next: ({ content, totalElements, numberOfElements }) => {
        this.loading = false;
        this.addressList = content;
        this.totalItems = totalElements;
        this.pageSize = numberOfElements;
      },
    });
  }

  pagination(event: any) {
    // this.offset = event.pageIndex * this.limit;
    this.form.get('offset')?.patchValue(event.pageIndex);
    // this.form.get('limit')?.patchValue(event.pageIndex)
    this.getAddresses();
  }
}
